module.exports = __webpack_public_path__ + "img/lily white_lw.810afe38.png";